import HorizontalScroll from "react-scroll-horizontal";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { useHorizontalScroll } from "../utils/browser.utils";

const SlidesLayout = ({ children, width = "5200px" }) => {
  // const scrollRef = useHorizontalScroll();
  return (
    <Content style={{}}>
      <HorizontalScroll reverseScroll={true}>
        <SlidesContainer width={width}>{children}</SlidesContainer>
      </HorizontalScroll>
    </Content>
  );
};

SlidesLayout.propTypes = {
  children: PropTypes.node.isRequired,
  overflow: PropTypes.string,
};

const SlidesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: ${props => props.width};
  overflow: visible;
  padding-left: 10vw;
  padding-top: 10vh;
`;

const Content = styled.div`
  margin: 0 auto;
  max-width: 1920px;
  height: 90vh;
  overflow-y: visible;
  overscroll-behavior: contain;
  padding: 1rem 1.0875rem 1.45rem;
  z-index: 300;
`;

export default SlidesLayout;
